export const emptySearchValue = '?searchValue=';

const links = {
    admin: {
        registration: '/admin/registration',
    },
    home: '/',
    registrationPages: {
        registration: '/registration',
        success: '/registration/success',
        memberServices: '/registration/member-services',
    },
    login: '/login',
    logout: '/logout',
    noPermissions: '/no-permissions',
    redirecting: '/redirecting',
    topics: {
        myFeed: '/questions',
        otherFeed: '/questions_other',
        view: '/questions/:id',
    },
    infoPages: {
        support: 'https://healthcasts.com/contact',
        registrationSupportForm: 'https://healthcasts.com/contactAC-1',
        about: 'https://healthcasts.com/about',
        faq: 'https://healthcasts.com/faq',
    },
    moderator: {
        consensus: {
            submit: '/moderator/submitSummary',
            preview: '/moderator/consensus-summary-preview/:id/:status',
        },
        peerChallenge: {
            preview: '/moderator/peer-challenge-preview/:id/:status',
        },
        users: {
            new: '/moderator/users/new',
            edit: '/moderator/users/:id',
            rewards: '/moderator/users/:id/rewards',
            index: '/moderator/users',
        },
        questions: {
            new: '/moderator/questions/new',
            npis: '/moderator/questions-npis',
            edit: '/moderator/questions/:id',
            details: '/moderator/questions/:id/details',
            index: '/moderator/questions',
        },
        globalPrograms: {
            index: '/moderator/global_programs/overview',
            createEmails: '/moderator/global_programs/create_emails',
        },
        search: {
            index: '/moderator/search',
        },
        design: {
            components: '/moderator/design/components',
        },
    },
    consensus: {
        all: '/consensuses',
        view: '/consensuses/:id',
    },
    my: {
        profile: '/my/profile',
        rewards: '/my/rewards',
    },
    resources: process.env.REACT_APP_APP_HC_RESOURCES_URL,
    submitPatientCase: process.env.REACT_APP_SUBMIT_CASE_URL,
    consensusMd: process.env.REACT_APP_CONSENSUS_MD_URL,
    myCasesAndConsults: `${process.env.REACT_APP_CONSENSUS_MD_URL}/my-cases-and-consults/`,
    cmdMyRewards: `${process.env.REACT_APP_CONSENSUS_MD_URL}/my-rewards/`,
    cmdUserProfile: `${process.env.REACT_APP_CONSENSUS_MD_URL}/user-profile/`,
    notFound: '/404', // can be any string that doesn't match a route in the router (and start with /)
};

export const privacyPolicyLink =
    'https://healthcasts.com/privacy';

export const termsOfServiceLink =
    'https://healthcasts.com/terms-of-service';

export const publicRoutes = Object.freeze([
    links.login,
    links.logout,
    links.noPermissions,
    links.registrationPages.registration,
    links.registrationPages.success,
    links.registrationPages.memberServices,
    links.infoPages.support,
]);

export default links;
